import { MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';
import React, { useCallback } from 'react';

import { editDataRequestItem } from '../../../services/dealGPT';
import { DataRequestItem } from '../../../Types/dealGPT';
import { DataRequestItemStatus, dataRequestItemStatusColors } from '../../../Types/enums';

interface DataRequestItemStatusSelectProps {
  item: DataRequestItem;
  onItemChanged: (newItem: DataRequestItem) => void;
}

export const DataRequestItemStatusSelect = ({
  item,
  onItemChanged,
}: DataRequestItemStatusSelectProps) => {
  const onStatusChange = useCallback(
    async (e: SelectChangeEvent<DataRequestItemStatus>) => {
      const newValue = e.target.value as DataRequestItemStatus;
      const newItem = await editDataRequestItem(item.projectId, {
        id: item.id,
        status: newValue,
      });

      onItemChanged(newItem);
    },
    [item.id, item.projectId, onItemChanged]
  );

  return (
    <Select size="small" value={item.status} onChange={onStatusChange} sx={{ width: '150px' }}>
      {Object.values(DataRequestItemStatus).map((s) => (
        <MenuItem key={s} value={s}>
          <Typography sx={{ fontWeight: 600, color: dataRequestItemStatusColors[s] }}>
            {s}
          </Typography>
        </MenuItem>
      ))}
    </Select>
  );
};
